import React from 'react';

const Logo = (props) => (
  <img alt="Logo" src="/static/logo.svg" height="30" {...props} />
);

export default Logo;
